import Axios from "axios";
import React, { Component } from "react";
import { Card, Button } from "antd";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

const { Meta } = Card;

class ListGameComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      games: null,
      statusForm: "read",
      name: "",
      genre: "",
      singlePlayer: "",
      multiplayer: "",
      platform: "",
      release: "",
      image_url: "",
      isFlipped: false,
    };
  }

  componentDidMount() {
    if (this.state.games === null) {
      const url = `https://backendexample.sanbersy.com/api/data-game`;
      Axios.get(url).then((res) => {
        const value = res.data;
        this.setState({
          games: value,
        });
      });
    }
  }

  render() {
    return (
      <>
        <Row className="mt-5">
          {this.state.games !== null &&
            this.state.games.map((m, index) => {
              return (
                <Col md="4" xs="12" className="mt-5 mb-5" key={index}>
                  <Card
                    hoverable
                    style={{ width: 240 }}
                    cover={<img alt="example" src={m.image_url} />}
                  >
                    <Meta title={m.genre} description={m.name} />
                    <Button className="mt-2">
                      <Link to={`/game/${m.id}`}>View More</Link>
                    </Button>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </>
    );
  }
}
export default ListGameComponent;
